<script>
import { mask } from "vue-the-mask";

export default {
  name: "AInput",
  directives: {
    mask,
  },
  props: {
    value: {
      required: true,
    },
    mask: {
      type: Array[String],
      default: undefined,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    // minLength: String,
    // maxLength: String,
    placeholder: {
      type: String,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      required: true,
      validator: value =>
        ["text", "email", "tel", "password", "checkbox", "radio"].includes(
          value
        ),
    },
  },
  data: () => ({
    localValue: null,
  }),
  mounted() {
    this.localValue = this.value;
  },
  computed: {
    hasMask() {
      return ["checkbox", "radio"].includes(this.type)
        ? false
        : this.mask.filter(item => item).length > 0;
    },
  },
};
</script>

<template lang="pug">
  input(
    data-cs-mask=""
    :id="id"
    v-if="hasMask"
    v-mask="mask"
    :type="type"
    :name="name"
    :placeholder="placeholder"
    class="border border-solid outline-none a-input placeholder-light-300 placeholder-font-normal border-light-300 hover:border-dark-0 focus:border-primary"
    @input="$emit('change', $event.target.value)"
    @blur="$emit('blur', $event.target.value)"
    :value="value"
    )
  input(
    data-cs-mask=""
    :id="id"
    v-else
    :type="type"
    :name="name"
    :placeholder="placeholder"
    class="border border-solid outline-none a-input placeholder-light-300 placeholder-font-normal border-light-300 hover:border-dark-0 focus:border-primary"
    @input="$emit('change', $event.target.value)"
    @blur="$emit('blur', $event.target.value)"
    :value="value"
    )
</template>

<style lang="scss" scoped>
input.a-input::placeholder {
  @apply font-normal;
}
input.a-input:not(:placeholder-shown) {
  @apply border-primary-0;
}
input.a-input:not(:placeholder-shown):focus {
  @apply border-primary;
}
input.a-input:disabled {
  @apply border-light-200;
  @apply bg-light-200;
  &::placeholder {
    @apply text-dark-0;
  }
}
input.a-input {
  @apply transition-all;
  @apply duration-100;
}

input.a-input:-webkit-autofill,
input.a-input:-webkit-autofill:hover,
input.a-input:-webkit-autofill:focus,
input.a-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px theme("colors.light.0") inset;
  box-shadow: 0 0 0 30px theme("colors.light.0") inset;
}
</style>
